export const DASHBOARD_SUMMARY = 'DASHBOARD_SUMMARY';
export const DASHBOARD_SALES = 'DASHBOARD_SALES';
export const DASHBOARD_TOP_RATED = 'DASHBOARD_TOP_RATED';
